import { connect } from 'react-redux';

import { getFilteredFunnels, getSelectedFunnel, getTenantId } from '../../../reducers/analyticsApp';
import { selectFunnel } from '../../../actions/funnel';
import CompoundExecutionPane from '../../../components/compound/execution/Pane';

const mapStateToProps = (state, { params }) => {
  const selectedFunnel = getSelectedFunnel(state);
  const launchSelectedFunnel = !!(
    !selectedFunnel || String(selectedFunnel.id) !== String(params.id)
  );

  return {
    item: getFilteredFunnels(state).find((item) => String(item.id) === String(params.id)),
    tenantId: getTenantId(state),
    launchSelectedFunnel,
    location: 'funnels',
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  launchFunnel: false,
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  if (!!stateProps.item && stateProps.launchSelectedFunnel) {
    dispatchProps.dispatch(selectFunnel(stateProps.item));
  }

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CompoundExecutionPane);
